import axios from "axios";

import buildPaginationQueryOpts from "@/shared/sort/sorts";

import { IProject } from "@/shared/model/project.model";

const baseApiUrl = 'api/projects';

export default class ProjectService {
  public find(id: number): Promise<IProject> {
    return new Promise<IProject>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  // find all by id in list
  public findList(ids: number[]): Promise<IProject[]> {
    return new Promise<IProject[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/list/${ids}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public filter(paginationQuery?: any, filter?: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/filter?${buildPaginationQueryOpts(paginationQuery)}&filter=${filter}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IProject): Promise<IProject> {
    return new Promise<IProject>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IProject): Promise<IProject> {
    return new Promise<IProject>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IProject): Promise<IProject> {
    return new Promise<IProject>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public search(paginationQuery?: any, keyword?: string, provinceId?: number): Promise<any> {
    const queryParam: { [key: string]: any } = {};
    if (keyword) queryParam.nameLike = keyword;
    else queryParam.nameLike = '';
    if (provinceId) queryParam.provinceId = provinceId;
    let queryParamKeys = Object.keys(queryParam);
    if (queryParamKeys.length > 0) {
      const queryParamBuild = queryParamKeys.map((k, id) => `${id == 0 ? '?' : '&'}${k}=${queryParam[k]}`);
      return new Promise<any>((resolve, reject) => {
        axios
          .get(`${baseApiUrl}-search${queryParamBuild}${buildPaginationQueryOpts(paginationQuery)}`)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }

  public thumbnail(id: number) {
    return `${baseApiUrl}/${id}/thumbnail`;
  }
}
